import { Dispatch, SetStateAction } from "react"
import { expressions } from "../libraries/regular.expressions.library"
import { controllerApproved } from "../utils/meter.security.util"
import { legendIconInvalidRequiredConfirmation, legendInvalidRequired, legendIconInvalidRequired, legendIconValidInvalidRequiredConfirmation, legendValidRequired, legendIconValidRequiredConfirmation, legendIconValidRequired } from "../utils/legend.data.util"

export function evaluatePassword(password: {value: string, valid: boolean}, set_password: Dispatch<SetStateAction<{value: string, valid: boolean}>>, identifier: string, container_1: string, container_2: string) {
  if (expressions) {
    let options: boolean[] = [false, false, false, false, false]

    options[0] = (expressions.islowercase.test(password.value)) ? true : false
    options[1] = (expressions.isuppercase.test(password.value)) ? true : false
    options[2] = (expressions.isnumber.test(password.value)) ? true : false
    options[3] = (expressions.issymbol.test(password.value)) ? true : false
    options[4] = (expressions.limit.test(password.value)) ? true : false

    if (options.every((item) => (item !== false))) {
      set_password({...password, valid: true})
      legendIconValidRequired(identifier, container_1, container_2)
    } else {
      set_password({...password , valid: false})
      legendIconInvalidRequired(password.value, identifier, container_1, container_2)
    }
  }
}

export function evaluatePasswordController(password: {value: string, valid: boolean}, set_password: Dispatch<SetStateAction<{value: string, valid: boolean}>>, input_container_1: string, input_container_2: string, controller_container_1: string, controller_container_2: string, controller_container_3: string, controller_container_4: string, controller_container_5: string) {
  if (expressions) {
    let options: boolean[] = [false, false, false, false, false]

    options[0] = (expressions.islowercase.test(password.value)) ? true : false
    options[1] = (expressions.isuppercase.test(password.value)) ? true : false
    options[2] = (expressions.isnumber.test(password.value)) ? true : false
    options[3] = (expressions.issymbol.test(password.value)) ? true : false
    options[4] = (expressions.limit.test(password.value)) ? true : false

    switch (options.filter((item) => (item === true)).length) {
      case 0:
        set_password({...password, valid: false})
        legendInvalidRequired(password.value, input_container_1, input_container_2)
        controllerApproved(0, controller_container_1, controller_container_2, controller_container_3, controller_container_4, controller_container_5)
        break;
      case 1:
        set_password({...password, valid: false})
        legendInvalidRequired(password.value, input_container_1, input_container_2)
        controllerApproved(1, controller_container_1, controller_container_2, controller_container_3, controller_container_4, controller_container_5)
        break;
      case 2:
        set_password({...password, valid: false})
        legendInvalidRequired(password.value, input_container_1, input_container_2)
        controllerApproved(2, controller_container_1, controller_container_2, controller_container_3, controller_container_4, controller_container_5)
        break;
      case 3:
        set_password({...password, valid: false})
        legendInvalidRequired(password.value, input_container_1, input_container_2)
        controllerApproved(3, controller_container_1, controller_container_2, controller_container_3, controller_container_4, controller_container_5)
        break;
      case 4:
        set_password({...password, valid: false})
        legendInvalidRequired(password.value, input_container_1, input_container_2)
        controllerApproved(4, controller_container_1, controller_container_2, controller_container_3, controller_container_4, controller_container_5)
        break;
      case 5:
        set_password({...password, valid: true})
        legendValidRequired(input_container_1, input_container_2)
        controllerApproved(5, controller_container_1, controller_container_2, controller_container_3, controller_container_4, controller_container_5)
        break;
    }
  }
}

export function evaluatePasswordConfirmation(is_input_password: boolean, password: {value: string, valid: boolean}, password_confirmation: {value: string, valid: boolean}, set_password_confirmation: Dispatch<SetStateAction<{value: string, valid: boolean}>>, identifier: string, container_1: string, container_2: string, container_3: string) {
  if (is_input_password && password.value.length === 0) {
    set_password_confirmation({...password_confirmation , valid: false})
    legendIconInvalidRequiredConfirmation(identifier, container_1, container_2, container_3)
  } else {
    if (expressions && password_confirmation.value.length > 0) {
      if (expressions.password.test(password_confirmation.value) && password_confirmation.value === password.value) {
        set_password_confirmation({...password_confirmation , valid: true})
        legendIconValidRequiredConfirmation(identifier, container_1, container_2, container_3)
      } else {
        set_password_confirmation({...password_confirmation , valid: false})
        legendIconValidInvalidRequiredConfirmation(expressions.password, password.value, password_confirmation.value, identifier, container_1, container_2, container_3)
      }
    } else {
      set_password_confirmation({...password_confirmation , valid: false})
      legendIconInvalidRequiredConfirmation(identifier, container_1, container_2, container_3)  
    }
  }
}
